import bowser from 'bowser';

// depends on outdatedbrowser.js
export function mixin(Hop) {
    Hop.getBrowserDesc = function () {
        let browser = bowser;
        if (browser.browser) {
            browser = browser.browser;
        }
        return browser || {};
    };

    Hop.isGoogleBot = function () {
        return window.navigator.userAgent.indexOf('Googlebot') > -1;
    };

    Hop.isExplicitlySupportedBrowser = function () {
        if (Hop.isOutdatedBrowser()) {
            return false;
        }

        const browser = Hop.getBrowserDesc();

        return browser.android || browser.chrome || browser.firefox || browser.opera || browser.msedge || browser.msie || browser.safari;
    };

    Hop.isOutdatedBrowser = function () {
        if (window.navigator.userAgent.indexOf('Node.js') === 0) {
            return false;
        }
        if (Hop.isGoogleBot()) {
            return false;
        }
        if (window.navigator.userAgent.indexOf('Page Speed') > -1) {
            return false;
        }

        const browser = Hop.getBrowserDesc();

        return (
            (browser.chrome && browser.version < 30)
            || (browser.firefox && browser.version < (browser.ios ? 15 : 28))
            || (browser.safari && browser.version < 8)
            || (browser.opera && browser.version < 30)
            || (browser.msie && browser.version < 10)
            || (browser.android && browser.osversion < 4)
        );
    };
}
